import React from "react";
import { TodoContext } from '../TodoContext';
import { PageHeader } from "../PageHeader";
import { TodoCounter } from '../TodoCounter';
// import { TodoSearch } from '../TodoSearch';
// import { DoItLater } from '../DoItLater';
// import { DoLaterItem } from "../DoLaterItem";
import { TodoList } from '../TodoList';
import { TodoItem } from '../TodoItem';
import { TodoForm } from '../TodoForm';
import { PreloadLists } from '../PreloadLists';
import { CreateTodoButton } from '../CreateTodoButton';
import { Modal } from '../Modal';
import { ModalList } from '../ModalList';
import { FormattedMessage } from 'react-intl';

function AppUI() {
    const {
      error,
      loading,
      searchedTodos,
      completeTodo,
      deleteTodo,
      openModal,
      setOpenModal,
      openModalList,
    } = React.useContext(TodoContext);

    return (
        <React.Fragment>

          <PageHeader />
          
          <TodoCounter />
          {/* <TodoSearch /> */}
    
          <TodoList>
            {error && <p><FormattedMessage id="app.error" defaultMessage="There was an error..."/></p>}
            {loading && <p><FormattedMessage id="app.loading" defaultMessage="Loading list..."/></p>}
            {(!loading && !searchedTodos.length) && <p><FormattedMessage id="app.loaded" defaultMessage="Create your first TODO!"/></p>}
            
            {searchedTodos.map(todo => (
              <TodoItem
                key={todo.text}
                text={todo.text}
                date={todo.date}
                completed={todo.completed}
                onComplete={() => completeTodo(todo.text)}
                onDelete={() => deleteTodo(todo.text)}
              />
            ))}
          </TodoList>
          <footer>
            <p>The design of this app was taken from this <a href="https://codepen.io/gfrancesca/pen/JXweoq">pen</a> by <a href="https://codepen.io/gfrancesca">Francesca</a>.</p>
          </footer>
          {!!openModal && (
            <Modal>
              <TodoForm></TodoForm>
            </Modal>
          )}

          {!!openModalList && (
              <ModalList>
                <PreloadLists></PreloadLists>
              </ModalList>
            )}
          <CreateTodoButton 
            setOpenModal={setOpenModal}
          />
        </React.Fragment>
    );
  }
  
  export { AppUI };